/* ej-product-cards: turn the article body's product list into cards.

   Joanne 2026-09-03, on the Carven piece: "I just don't want our sample products to be a
   list - I want it to be inviting", pointing at how Perfumes Club shows an image, the house,
   the piece and a price inside the article.

   The pipeline writes an honest list of links into the article body and nothing else: no
   image, no price, no availability. Everything a card shows is read HERE from the live
   storefront (/products/<handle>.js) at render time, so an article can never display a stale
   price. If a product cannot be read, its list item is left exactly as written - a working
   link. Nothing is invented and nothing is substituted.

   Stock is deliberately not shown. Pre-launch the catalogue reads zero and will refresh when
   the suppliers reconnect, so availability is not an editorial signal.

   Source: theme/assets/ej-product-cards.js */
(function () {
  "use strict";

  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    // shop.money_format can carry markup, e.g. "<span class=money>€{{amount}}</span>". The card
    // sets textContent, so any tag left in would print as literal code on the page.
    if (typeof format === "string") {
      format = format.replace(/<[^>]*>/g, "").trim();
    }
    // Shopify's money_format is a template like "€{{amount}}" or "£{{amount_with_comma_separator}}".
    if (typeof format === "string" && format.indexOf("{{") !== -1) {
      if (format.indexOf("comma_separator") !== -1) {
        value = value.replace(".", ",");
      }
      return format.replace(/\{\{\s*\w+\s*\}\}/, value);
    }
    return value;
  }

  function card(product, href, fallbackTitle) {
    var li = document.createElement("li");
    li.className = "ej-product-card";

    var a = document.createElement("a");
    a.className = "ej-product-card__link";
    a.href = href;

    var img = product.featured_image || (product.images && product.images[0]);
    if (img) {
      var figure = document.createElement("div");
      figure.className = "ej-product-card__media";
      var el = document.createElement("img");
      el.src = img.indexOf("?") === -1 ? img + "?width=400" : img;
      el.alt = product.title || fallbackTitle || "";
      el.loading = "lazy";
      el.decoding = "async";
      figure.appendChild(el);
      a.appendChild(figure);
    }

    var body = document.createElement("div");
    body.className = "ej-product-card__body";

    if (product.vendor) {
      var vendor = document.createElement("span");
      vendor.className = "ej-product-card__vendor";
      vendor.textContent = product.vendor;
      body.appendChild(vendor);
    }

    var title = document.createElement("span");
    title.className = "ej-product-card__title";
    // The house is already the eyebrow, so it is not repeated in the name.
    var name = product.title || fallbackTitle || "";
    if (product.vendor && name.toLowerCase().indexOf(product.vendor.toLowerCase()) === 0) {
      name = name.slice(product.vendor.length).replace(/^[\s–—-]+/, "");
    }
    title.textContent = name;
    body.appendChild(title);

    var prices = (product.variants || []).map(function (v) { return v.price; })
      .filter(function (p) { return typeof p === "number"; });
    if (prices.length) {
      var low = Math.min.apply(null, prices);
      var high = Math.max.apply(null, prices);
      var price = document.createElement("span");
      price.className = "ej-product-card__price";
      var fmt = window.EJ_MONEY_FORMAT;
      price.textContent = (high > low ? "From " : "") + money(low, fmt);
      body.appendChild(price);
    }

    var cta = document.createElement("span");
    cta.className = "ej-product-card__cta";
    cta.textContent = "View";
    body.appendChild(cta);

    a.appendChild(body);
    li.appendChild(a);
    return li;
  }

  function handleFrom(href) {
    var m = /\/products\/([^/?#]+)/.exec(href || "");
    return m ? m[1] : null;
  }

  function upgrade(list) {
    var items = Array.prototype.slice.call(list.querySelectorAll("li"));
    if (!items.length) return;
    var jobs = items.map(function (li) {
      var a = li.querySelector("a[href]");
      var handle = a && handleFrom(a.getAttribute("href"));
      if (!handle) return Promise.resolve(null);
      return fetch("/products/" + handle + ".js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return p ? { li: li, product: p, href: a.getAttribute("href"), title: a.textContent } : null; })
        .catch(function () { return null; });
    });

    Promise.all(jobs).then(function (results) {
      var got = results.filter(Boolean);
      // All or nothing: a half-upgraded list would read as a mistake rather than a design.
      if (got.length !== items.length) return;
      got.forEach(function (r) {
        r.li.replaceWith(card(r.product, r.href, r.title));
      });
      list.classList.add("ej-product-grid--cards");
    });
  }

  function run() {
    var lists = document.querySelectorAll(".ej-product-grid");
    Array.prototype.forEach.call(lists, upgrade);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
